import { ProductRelationToPrincipalEnum, ProductRuleTypeEnum } from './../../../../../../service/dto-insurance';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormArray, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-product-edit-rule-modal',
	standalone: false,
	templateUrl: './product-edit-rule-modal.component.html',
	styleUrl: './product-edit-rule-modal.component.scss'
})
export class ProductEditRuleModalComponent implements OnInit, OnDestroy {
	@Input() formArray!: FormArray;
	@Input() formControl?: FormGroup;

	form!: FormGroup;

	availableRuleTypes: ProductRuleTypeEnum[] = [
		'EntryAgeFrom', 'EntryAgeTo', 'MaxAge', 'InstanceCount',
		'WaitingPeriodSuicide', 'WaitingPeriodAccidental',
		'WaitingPeriodNatural', 'WaitingPeriodPreExistingCondition'
	];

	availableAppliedTos: ProductRelationToPrincipalEnum[] = [
		'MainMember', 'Spouse', 'Child', 'ChildStillBorn', 'ChildStudent','All'
	];

	constructor(private fb: FormBuilder, private modalRef: NzModalRef) { }

	ngOnInit(): void {
		// Seed values from the existing FormGroup when editing, otherwise use defaults
		const existing = this.formControl?.getRawValue();

		this.form = this.fb.group({
			id: [existing?.id ?? ''],
			ruleType: [existing?.ruleType ?? '', Validators.required],
			appliedTo: [existing?.appliedTo ?? '', Validators.required],
			threshold: [existing?.threshold ?? 0, Validators.required],
		});
	}

	ngOnDestroy(): void { }

	onCancel(): void {
		this.modalRef.close();
	}

	onSave(): void {
		if (this.form.invalid) {
			Object.values(this.form.controls).forEach(control => {
				control.markAsDirty();
				control.updateValueAndValidity();
			});
			return;
		}

		const rule = this.form.getRawValue();

		if (this.formControl) {
			// Edit mode — patch the original FormGroup so all its validators are preserved
			this.formControl.patchValue(rule);
		} else {
			// Add mode — push a fresh FormGroup built from the saved values
			this.formArray.push(
				this.fb.group({
					id: [rule.id],
					ruleType: [rule.ruleType, Validators.required],
					appliedTo: [rule.appliedTo, Validators.required],
					threshold: [rule.threshold, Validators.required],
				})
			);
		}

		this.modalRef.close(rule);
	}
}
